import { useEffect, useRef } from "react";
import { ArrowRight, Check } from "lucide-react";
import { Button } from "../../components/ui/button/button.tsx";
import styles from "./growth-submission-success.module.css";
import type { GrowthCategory } from "./growth-types.ts";

const headings: Record<GrowthCategory, string> = {
  CONTRIBUTION: "Thanks for sharing your interest.",
  LEARNING: "Your learning goal is shared.",
  CERTIFICATION: "Your certification interest is shared.",
  INNOVATION: "Thanks for sharing your idea.",
  LAUNCHING: "Thanks for sharing what you’ve built.",
  KNOWLEDGE_SHARING: "Thanks for sharing your session idea.",
};

export default function GrowthSubmissionSuccess({ growthCategory, onViewInitiative, onBack }: {
  growthCategory: GrowthCategory;
  onViewInitiative: () => void;
  onBack: () => void;
}) {
  const heading = useRef<HTMLHeadingElement>(null);
  useEffect(() => { heading.current?.focus(); }, []);

  return <section className={styles.panel} aria-labelledby="growth-success-title">
    <span className={styles.icon}><Check size={34} strokeWidth={2.2} aria-hidden /></span>
    <h1 id="growth-success-title" ref={heading} tabIndex={-1}>{headings[growthCategory] || "Your initiative is shared."}</h1>
    <p>{growthCategory === "INNOVATION"
      ? "Your idea has been received. You can follow updates and next steps here in CaeliusOne."
      : growthCategory === "LAUNCHING"
        ? "Your solution has been shared. You can follow updates and next steps here in CaeliusOne."
      : growthCategory === "KNOWLEDGE_SHARING"
        ? "We’ve received your idea. You’ll be able to follow updates and next steps here."
      : growthCategory === "CONTRIBUTION"
        ? "We’ve received it. You can follow the next steps here in CaeliusOne."
        : "You can follow any updates and next steps here in CaeliusOne."}</p>
    <div className={styles.actions}>
      <Button onClick={onViewInitiative}>View My Initiative <ArrowRight size={18} aria-hidden /></Button>
      <Button variant="muted-outline" onClick={onBack}>Back to Growth &amp; Initiatives</Button>
    </div>
  </section>;
}
